"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProjectsModal_1 = __importDefault(require("./ProjectsModal"));
exports.default = ProjectsModal_1.default;
